document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function() {  
    document.querySelectorAll('.product-card .product-featured-image .product-featured-image-link img.product-secondary-image').forEach(function(img) {
        img.setAttribute('aria-hidden', 'true');
    });
     document.querySelectorAll('.complementary-products img').forEach(function(img) {
        img.setAttribute('aria-hidden', 'true');
    });
    let hidebannerimage = document.querySelector('.collection-banner--image img');
        if(hidebannerimage){
          hidebannerimage.setAttribute('alt', '');
        }
        
  }, 1000);
  const parentElements = document.querySelectorAll('.thb-full-menu li[aria-haspopup=true]');
  const chilsparentElements = document.querySelectorAll('ul.sub-menu li.menu-item-has-children');

  parentElements.forEach(function (item) {
    item.addEventListener('mouseover', function () {
      item.classList.add('is-expanded');
      showSubmenu(item);
    });
    item.addEventListener('mouseout', function () {
      item.classList.remove('is-expanded');
      hideSubmenu(item);
    });
    item.addEventListener('focusin', function () {
      item.classList.add('is-expanded');
      showSubmenu(item);
    });
    item.addEventListener('focusout', function (event) {
      // Delay the check to see if focus is still within the parent element
      setTimeout(function () {
        if (!item.contains(document.activeElement)) {
          item.classList.remove('is-expanded');
          hideSubmenu(item);
        }
      }, 50);
    });
  });

  chilsparentElements.forEach(function (item) {
    item.addEventListener('mouseover', function () {
      item.classList.add('is-expanded');
      showSubmenu(item);
    });
    item.addEventListener('mouseout', function () {
      item.classList.remove('is-expanded');
      hideSubmenu(item);
    });
    item.addEventListener('focusin', function () {
      item.classList.add('is-expanded');
      showSubmenu(item);
    });
    item.addEventListener('focusout', function (event) {
      // Delay the check to see if focus is still within the parent element
      setTimeout(function () {
        if (!item.contains(document.activeElement)) {
          item.classList.remove('is-expanded');
          hideSubmenu(item);
        }
      }, 50);
    });
  });

  const menuLinks = document.querySelectorAll('.thb-full-menu li[aria-haspopup=true] > a');
  menuLinks.forEach(function (menuLink) {
    menuLink.setAttribute('aria-expanded', 'false');
  });

  const childmenuLinks = document.querySelectorAll('ul.sub-menu li.menu-item-has-children > a');
  childmenuLinks.forEach(function (menuLink) {
    menuLink.setAttribute('aria-expanded', 'false');
  });
  
  const submenuLinks = document.querySelectorAll('.thb-full-menu li .sub-menu');
  submenuLinks.forEach(function (submenuLink) {
    submenuLink.setAttribute('aria-hidden', 'true');
    submenuLink.style.display = 'none';
  });

  const observer = new MutationObserver(function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const parentElement = mutation.target;
        const links = parentElement.querySelector('a');
        const submenu = parentElement.querySelector('.sub-menu');

        if (submenu) {
          const isExpanded = parentElement.classList.contains('is-expanded');
          submenu.setAttribute('aria-hidden', isExpanded ? 'false' : 'true');
          submenu.style.display = isExpanded ? '' : 'none';
        }

        if (links) {
          links.setAttribute('aria-expanded', parentElement.classList.contains('is-expanded') ? 'true' : 'false');
        }
      }
    });
  });

  parentElements.forEach(function (parentElement) {
    observer.observe(parentElement, { attributes: true });
  });

  const menuContainer = document.querySelector('.thb-full-menu');
  menuContainer.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      const focusedElement = document.activeElement;

      if (focusedElement.closest('.is-expanded')) {
        const parentLink = focusedElement.closest('.is-expanded');
        const anchorChild = parentLink.querySelector('a');
        anchorChild.setAttribute('aria-expanded', 'false');
        anchorChild.focus();

        setTimeout(() => {
          parentLink.classList.remove('is-expanded');
          const submenu = parentLink.querySelector('.sub-menu');
          if (submenu) {
            submenu.setAttribute('aria-hidden', 'true');
            submenu.style.display = 'none';
          }
        }, 50);
      }
    }
  });

  function showSubmenu(item) {
    const submenu = item.querySelector('.sub-menu');
    const childAnchor = item.querySelector('a[aria-expanded="false"]');
    
    if (childAnchor) {  // Null check for childAnchor
      childAnchor.setAttribute('aria-expanded', 'true'); 
    }
    
    if (submenu) {      
      submenu.style.display = '';
      submenu.setAttribute('aria-hidden', 'false');      
    }
  }

  function hideSubmenu(item) {
    const submenu = item.querySelector('.sub-menu');
    const childAnchor = item.querySelector('a[aria-expanded="true"]');
    
    if (childAnchor) {  // Null check for childAnchor
      childAnchor.setAttribute('aria-expanded', 'false'); 
    }
    
    if (submenu) {
      submenu.style.display = 'none';
      submenu.setAttribute('aria-hidden', 'true');
    }
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const closeButtons = document.querySelectorAll('.side-panel-close');
  
  closeButtons.forEach(closeButton => {
    closeButton.addEventListener('keydown', function(event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        closeButton.click();
      }
    });
    
    closeButton.setAttribute('tabindex', '0');
  });
});


//For custom tabs
// function updateAriaSelected() {
//   const tabs = document.querySelectorAll('.side-panel-content--tabs .custom_tab');
//   console.log('sdfsdgsdgsgsg', tabs);
//   tabs.forEach(tab => {
//     const isActive = tab.classList.contains('tab-active');
//     tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
//   });
// }
// function initMutationObserver() {
//   const sidePanel = document.querySelector('.side-panel-inner');
//   if (!sidePanel) return;
//   const observer = new MutationObserver(() => {
//     // Use setTimeout to delay the execution of updateAriaSelected
//     setTimeout(() => {
//       updateAriaSelected();
//     }, 1000); // 1000 milliseconds = 1 second
//   });
//   // const observer = new MutationObserver(() => {
//   //   updateAriaSelected();
//   // });
//   observer.observe(sidePanel, { childList: true, subtree: true });
//   updateAriaSelected();
// }
// document.addEventListener('DOMContentLoaded', initMutationObserver);

//For custom tabs in search
// Function to initialize roles and aria attributes
function initializeTabs() {
  const tabContainer = document.querySelector("#Search-Drawer .side-panel-content--tabs");

  if (tabContainer) {

    // Get all buttons inside the tab container
    const tabs = tabContainer.querySelectorAll("button");

    tabs.forEach(tab => {

      // Set aria-selected="true" for the button with class 'tab-active'
      if (tab.classList.contains("tab-active")) {
        tab.setAttribute("aria-selected", "true");
      } else {
        // Set aria-selected="false" for other buttons
        tab.setAttribute("aria-selected", "false");
      }

      // Add click event listener to toggle aria-selected on user interaction
      tab.addEventListener("click", function() {
        tabs.forEach(t => {
          t.setAttribute("aria-selected", "false");
        });

        // Activate the clicked tab
        this.setAttribute("aria-selected", "true");
      });
    });
  }
}

// MutationObserver callback to detect changes in the DOM
const observerCallback = function(mutationsList, observer) {
  for (const mutation of mutationsList) {
    if (mutation.type === "childList") {
      initializeTabs();
      observer.disconnect(); // Once initialized, we stop observing to avoid repeated execution
    }
  }
};

// Create a MutationObserver to observe changes in the #Search-Drawer element
const observer = new MutationObserver(observerCallback);

// Start observing the #Search-Drawer element for child nodes being added
const searchDrawer = document.getElementById("Search-Drawer");

if (searchDrawer) {
  observer.observe(searchDrawer, { childList: true, subtree: true });
}

// Call initializeTabs once DOM is loaded in case the content is already there
document.addEventListener("DOMContentLoaded", initializeTabs);


//Updating label of the modal dialog
// function updateModal() {
//   // Set the delay (in milliseconds) after which the modal appears
//   const delay = 3000; // 3 seconds
//   // console.log('test');
  
//   // Wait for the modal to appear after the page load
//   setTimeout(function() {
//     // Select the modal dialog element by its ID or class (replace with the actual selector)
//     const modal = document.querySelector('.needsclick div[role="dialog"]');
//     const modalHeading = document.getElementById('rich-text-124092191');
//     var modalSubmitBtn = document.querySelector('.needsclick div[role="dialog"] form button');
    
//     // Check if the modal exists
//     if (modal) {
//       // Update the aria-label attribute
//       modalHeading.setAttribute('role', 'heading');
//       modalHeading.setAttribute('aria-level', '2');
//       modal.setAttribute('aria-labelledby', 'rich-text-124092191');
//       modal.removeAttribute('aria-label');
//       modalSubmitBtn.addEventListener('focus', handleFocus);
//       modalSubmitBtn.addEventListener('blur', handleBlur);
//     }
//   }, delay);
// }
// function handleFocus(event) {
//   // Add outline when button is focused
//   event.target.style.outline = '3px dashed black'; // Customize the outline as needed
// }

// // Function to remove outline when focus is lost
// function handleBlur(event) {
//   event.target.style.outline = 'none'; // Reset outline when focus is removed
// }

// // Call the dialog function using mutation observer
// const observer1 = new MutationObserver((mutationsList, observer1) => {
//     // Loop through all mutations that just occurred
//     mutationsList.forEach(mutation => {
//         // Check if any new nodes are added to the DOM
//         mutation.addedNodes.forEach(node => {
//             // Check if the added node is a div with role="dialog"
//             if (node.nodeType === 1 && node.matches('div.needsclick[role="dialog"]')) {
//                 // Call the updateStyle function
//                 updateModal();
//             }
//         });
//     });
// });

// // Start observing the entire document for child node additions
// observer.observe(document.body, {
//     childList: true, // Look for direct children added or removed
//     subtree: true    // Observe all levels, not just direct children
// });
// const tabContainer = document.querySelectorAll('jdgm_review_reviewer_name_qcplyp26f');
// console.log('dsfsdvsdvdxv', tabContainer);

// Function to apply the required changes to the dialog and its components
function handleDialogChanges(element) {
    // Select the dialog
    const dialog = document.querySelector('div.needsclick[role="dialog"]');
    
    if (dialog) {
        // 1. Remove aria-label from the dialog
        dialog.removeAttribute('aria-label');
        //get heading element id
        const ListHead = dialog.querySelectorAll('div[id*="rich-text-"]');
        const firstHead = ListHead[0];
        const HeadID = firstHead.getAttribute('id');

        // 2. Add aria-labelledby with value 'rich-text-124092191' to the dialog
        dialog.setAttribute('aria-labelledby', HeadID);

        // 3. Add role="heading" and aria-level="2" to div with id="rich-text-124092191"
        // const headingDiv = dialog.querySelector('#rich-text-124092191');
        if (firstHead) {
            firstHead.setAttribute('role', 'heading');
            firstHead.setAttribute('aria-level', '2');
        }

        //4. Update placeholder name for the form fields
        const email = dialog.querySelector('input[name="email"]');

        if (email) {
          const emailID = email.getAttribute('id');
          const emailLabel = document.createElement('label');
          emailLabel.setAttribute('for', emailID); // Associate the label with the email field
          emailLabel.classList.add('visually-hidden'); // Add the visually hidden class
          emailLabel.textContent = 'Email (required)';
          email.parentElement.insertBefore(emailLabel, email);
          email.setAttribute('placeholder', 'Email (required)');
          email.addEventListener('input', () => {
            emailLabel.classList.remove('visually-hidden');
            });
          email.addEventListener('blur', () => {
            if (!email.value) {
              emailLabel.classList.add('visually-hidden');
              }
            });
        }
        const firstName = dialog.querySelector('input[autocomplete="given-name"]');

        if (firstName) {
          const firstNameID = email.getAttribute('id');
          const fNameLabel = document.createElement('label');
          fNameLabel.setAttribute('for', firstNameID); // Associate the label with the email field
          fNameLabel.classList.add('visually-hidden'); // Add the visually hidden class
          fNameLabel.textContent = 'First Name';
          firstName.parentElement.insertBefore(fNameLabel, firstName);
          firstName.addEventListener('input', () => {
            fNameLabel.classList.remove('visually-hidden');
            });
          firstName.addEventListener('blur', () => {
            if (!firstName.value) {
              fNameLabel.classList.add('visually-hidden');
              }
            });
        }

        // 5. Set outline of '3px dashed black' to button on focus and remove outline on blur
        const button = dialog.querySelector('form button');
        if (button) {
            // Add focus event listener to set outline
            button.addEventListener('focus', function() {
                this.style.outline = '3px dashed black';
            });

            // Add blur event listener to remove outline
            button.addEventListener('blur', function() {
                this.style.outline = 'none';
            });
        }
    }
    else {
    setTimeout(handleDialogChanges, 5000); //wait 5s, then try again
    }
}

//Calling functions on complete page load
window.addEventListener('load', function() {
  handleDialogChanges();
  averageRatings();
  ratingFocus();
  // quantityUpdate();
  updateStarRating();
  productImageMouseClick();
});

//provide hidden rating to the star rating for product
function updateStarRating() {
    // Select the element with class 'star-rating'
    const starRatingElement = document.querySelector('.star-rating');
    if(starRatingElement){
      // Extract the value of --star-rating from the style attribute
      const styleValue = getComputedStyle(starRatingElement).getPropertyValue('--star-rating').trim();
      
      // Create a visually hidden span
      const hiddenSpan = document.createElement('span');
      hiddenSpan.classList.add('visually-hidden'); // Adding visually hidden class for accessibility
      hiddenSpan.textContent = `Rating: ${styleValue} out of 5 stars`;
    
    // Insert the hidden span into the star-rating element
    // starRatingElement.innerHTML = ''; // Clear the inner content of star-rating
      starRatingElement.appendChild(hiddenSpan);
      }
}


//proving label to sort
document.addEventListener('DOMContentLoaded', function() {
  setTimeout(function() {
    var sortlabel = document.querySelector('.jdgm-sort-dropdown');
    // console.log('sortlabel is found', sortlabel);
  
    if (sortlabel) {
      sortlabel.setAttribute('aria-label', 'Sort By');
    }
  }, 1000);
});


document.addEventListener('DOMContentLoaded', function() {
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      const imageAlt = document.querySelector('.custom_image');
      if (imageAlt) {
        imageAlt.setAttribute("alt", "");
        observer.disconnect();
      }
    });
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


//Labelling star ratings
function averageRatings() {
  setTimeout(function() {
    const averageElements = document.querySelector('.jdgm-rev-widg__summary-average');
    if (averageElements) {
      const averageRating = averageElements.textContent.trim();
      const ratingImage = averageElements.closest('.jdgm-rev-widg__summary-stars');
      ratingImage.setAttribute('aria-label', `Average rating is ${averageRating} stars`);
    }
  }, 3000);
}

//Review ratings focus setting
function ratingFocus() {
  const ratingLink = document.querySelector('a.star-rating-container');
  if (ratingLink) {
    const ratingHref = ratingLink.getAttribute('href').trim();
    const ratingContainer = document.querySelector('div.jdgm-review-widget');
    if(ratingContainer){
      const ratingContainerID = ratingContainer.getAttribute('id');
      if(ratingHref !== ratingContainerID) {
        ratingLink.setAttribute('href', `#${ratingContainerID}`);
        ratingLink.addEventListener('click', function(e) {
          e.preventDefault();
          ratingContainer.setAttribute('tabindex', '-1');
          ratingContainer.focus();
          // setTimeout(function() {
          //   ratingContainer.removeAttribute('tabindex');
          // }, 500);       
        });
    }
    }
  }
}

function quantityUpdate(){
  const LiveQuantityUpdate = document.getElementByID('quantityIndicator');
  const quantityIncrement = document.querySelector('quantity-selector button.plus');
  const quantityDecrement = document.querySelector('quantity-selector button.minus');

  if (quantityIncrement) {
    quantityIncrement.addEventListener('click', function(){
      LiveQuantityUpdate.textContent('Product quantity increased by 1');
      setTimeout(() => {
            LiveQuantityUpdate.textContent = '';
        }, 2000);
    });
  }
  if (quantityDecrement) {
    quantityDecrement.addEventListener('click', function(){
      LiveQuantityUpdate.textContent('Product quantity descreased by 1');
      setTimeout(() => {
            LiveQuantityUpdate.textContent = '';
        }, 2000);
    });
  }
}

//Providing CC for Write a review 
document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.jdgm-histogram__frequency');
    elements.forEach(element => {
        element.style.color = '#000000';
    });
    const timestampElements = document.querySelectorAll('.jdgm-rev__timestamp');
    timestampElements.forEach(element => {
        element.style.color = '#000000';
    });
});


// document.addEventListener('DOMContentLoaded', () => {
//   setTimeout(function() {
//     const fot = document.querySelector('.shopify-installments__content');
//     // console.log('sdfsdvsd', fot);
//   }, 1000);
// });

function productImageMouseClick() {
  setTimeout(function() {
  const clickableProdDivs = document.querySelectorAll('div.product-featured-image-link[role="none"]');

  //Add event listener to each div
  clickableProdDivs.forEach(div => {
    // e.preventDefault();
    div.addEventListener('click', function(event) {
      if (event.target.tagName.toLowerCase() !== 'quick-view') {
            // Retrieve the href value from the div
            const href = this.getAttribute('href');
            
            // Open the page using the href value
            if (href) {
                window.location.href = href;
            }
        }
    });
  });
  }, 3000);
}
// document.addEventListener('load', () => {
//   const clickableProdDivs = document.querySelectorAll('div.product-featured-image-link[role="none"]');
//   // Add event listener to each div
//   clickableProdDivs.forEach(div => {
//     // e.preventDefault();
//     div.addEventListener('click', function(event) {
//       if (event.target.tagName.toLowerCase() !== 'quick-view') {
//             // Retrieve the href value from the div
//             const href = this.getAttribute('href');
            
//             // Open the page using the href value
//             if (href) {
//                 window.location.href = href;
//             }
//         }
//     });
//   });
// });

document.addEventListener('DOMContentLoaded', function () {
    var scrollingTexts = document.querySelectorAll('.scrolling-text--inner');
    var toggleButton = document.getElementById('scroll-toggle'); 
    var isPaused = false; 
  if(toggleButton){
    toggleButton.addEventListener('click', function () {
        scrollingTexts.forEach(function(scrollingText) {
            if (isPaused) {
                scrollingText.style.setProperty('--marquee-speed', '50s');
                scrollingText.style.animationPlayState = 'running';
            } else {
                scrollingText.style.setProperty('--marquee-speed', '0s');
                scrollingText.style.animationPlayState = 'paused';
            }
        });
        if (isPaused) {
            toggleButton.textContent = 'Pause';
        } else {
            toggleButton.textContent = 'Play';
        } 
        isPaused = !isPaused;
    });
  }
});



//Focus on dialog
function openDrawer() {
    const drawer = document.getElementById('Product-Drawer');
    const closeButton = drawer.querySelector('.side-panel-close');
    const focusableElements = getFocusableElements(drawer);
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');

    setTimeout(() => {
        if (closeButton) {
            closeButton.focus();
            drawer.addEventListener('keydown', trapFocus); // Add event listener to trap focus
        } else {
            console.warn('Close button not found');
        }
    }, 100);
}

function trapFocus(event) {
    const drawer = document.getElementById('Product-Drawer');
    const focusableElements = getFocusableElements(drawer);
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    if (event.key === 'Tab') {
        if (event.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
                event.preventDefault();
                lastFocusableElement.focus();
            }
        } else {
            if (document.activeElement === lastFocusableElement) {
                event.preventDefault();
                firstFocusableElement.focus();
            }
        }
    }
}

function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            'a, button, textarea, input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])'
        )
    ).filter(el => !el.hasAttribute('disabled') && el.offsetParent !== null);
}

function handleQuickViewActivation(event) {
    if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openDrawer();
    }
}

setTimeout(() => {
    const quickViewButtons = document.querySelectorAll('.product-card-quickview'); // Define quickViewButtons here
    quickViewButtons.forEach(quickView => {
        quickView.addEventListener('click', handleQuickViewActivation);
        quickView.addEventListener('keydown', handleQuickViewActivation); // Listen for keydown events
    });
}, 1500);

//hiding unneccasry button in quick view
function isSidePanelActive() {
    return document.querySelector('.product-drawer').classList.contains('active');
}

// Function to update aria-hidden and tabindex attributes
function updateAccessibilityAttributes() {
    const variantPicker = document.querySelector('.product-popup-modal__button');
    
    if (variantPicker) {
        if (isSidePanelActive()) {
            variantPicker.setAttribute('aria-hidden', 'true');
            variantPicker.setAttribute('tabindex', '-1');
        } else {
            variantPicker.setAttribute('aria-hidden', 'false');
            variantPicker.removeAttribute('tabindex');
        }
    }
}
updateAccessibilityAttributes();


//focus to size chart
document.addEventListener('DOMContentLoaded', function() {
    const variantPicker = document.getElementById('ProductPopup-variant_picker');
    if (variantPicker) {
        variantPicker.addEventListener('click', function() {
            // Show the modal dialog
            const modal = document.querySelector('.product-popup-modal');
            modal.style.display = 'block'; // or use a class to handle visibility

            // Set focus to the first interactive element
            const firstInteractiveElement = modal.querySelector('input, button, select, textarea');
            if (firstInteractiveElement) {
                firstInteractiveElement.focus();
            }
        });
    } else {
        console.log('Element with ID "ProductPopup-variant_picker" not found.');
    }
});



//Size chart dialog
document.addEventListener('DOMContentLoaded', function () {
    const openModalButton = document.querySelector('#ProductPopup-variant_picker');
    if (!openModalButton) {
        console.log('Open modal button not found');
        return; // Exit early if the button doesn't exist
    }

    const modal = document.querySelector('.product-popup-modal__content');
    let focusableElements;
    let firstFocusableElement;
    let lastFocusableElement;

    // Function to trap focus inside the modal
    function trapFocus(event) {
        const isTabPressed = (event.key === 'Tab' || event.keyCode === 9);

        if (!isTabPressed) {
            return;
        }

        if (event.shiftKey) {
            if (document.activeElement === firstFocusableElement) {
                event.preventDefault();
                lastFocusableElement.focus();
            }
        } else {
            if (document.activeElement === lastFocusableElement) {
                event.preventDefault();
                firstFocusableElement.focus();
            }
        }
    }

    // Open modal and trap focus
    function openModal() {
        const modal = document.querySelector('.product-popup-modal__content'); // Check for modal
        if (!modal) return; // Check if modal exists

        const closeModalButton = modal.querySelector('.product-popup-modal__toggle'); // Check for close button

        focusableElements = modal.querySelectorAll(
            'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
        );
        firstFocusableElement = focusableElements[0];
        lastFocusableElement = focusableElements[focusableElements.length - 1];

        setTimeout(() => {
            firstFocusableElement.focus();
        }, 50);

        modal.addEventListener('keydown', trapFocus);

        // Listen for close button
        if (closeModalButton) {
            closeModalButton.addEventListener('click', closeModal);
        }
    }

    // Close modal and return focus to the button
    function closeModal() {
        const modal = document.querySelector('.product-popup-modal__content');
        if (modal) {
            modal.removeEventListener('keydown', trapFocus);
            const closeModalButton = modal.querySelector('.product-popup-modal__toggle');
            if (closeModalButton) closeModalButton.click();
        }
        openModalButton.focus();
    }

    // Button click to open the modal
    openModalButton.addEventListener('click', openModal);

    window.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            closeModal();
        }
    });
});


















